import { LeadConfiguration } from "./configuration";
import { Customer } from "./customer";
import { Translations } from "./translations";
import { OwnerUser, User } from "./user";
import { MediaFile, NoteTypes } from ".";
import { VehicleModelMinimal } from "./vehicleModal";
import { VehicleVariantMinimal } from "./vehicleVariant";
import { ITimePeriodData } from "../../components/time-period/custom-time-period";
import { IShowrrom } from "../../components/calendar/big-calendar-component";
import { Showroom } from "./showroom";
import { Company, GenericDocuments, Proposal } from "..";
import { LeadRequirement } from "./requirement";

export enum LeadNewnesses {
  New = "new",
  FollowUp = "follow-up",
  ReturningCustomer = "returning-customer",
}

export enum LeadStatuses {
  Lead = "lead",
  Deal = "deal",
  Spam = "spam",
  Lost = "lost",
  Won = "won",
}

export enum LeadQuality {
  NotIntrested = "notIntrested",
  Interested = "interested",
  NotInterestedNow = "notInterestedNow",
}

export enum LeadIntents {
  Sales = "sales",
}

export enum Priorities {
  Highest = "highest",
  High = "high",
  Normal = "normal",
  Medium = "medium",
  Low = "low",
  Lowest = "lowest",
}

export enum LeadQualityReasons {
  NoAnswerMobileOff = "noAnswer/MobileOff",
  NotInterested = "notInterested",
  WrongNumber = "wrongNumber",
  InterestedLater = "interestedLater",
  RepeatedLeads = "repeatedLeads",
  RegisteredWithNoContact = "registeredWithNoContact",
}

export enum ActivityTypes {
  ChangeLog = "changeLog",
  Note = "note",
  Activity = "activity",
}

export enum AppointmentTypes {
  // scheduleATestDrive = "Schedule A TestDrive",
  // showroomAppointment = "Showroom Appointment",
  call = "Call",
  meeting = "Meeting",
  task = "Task",
  deadline = "Deadline",
}

export enum LeadStage {
  lead = "Lead",
  enquiry = "Opportunity",
  requirement = "Requirement",
  proposal = "Proposal",
  cslInitial = "CSL Initial",
  siteVisit = "Site Visit",
  cslFinal = "CSL FInal",
  termSheet = "Term Sheet",
  feeConfirmation = "Fee Confirmation",
  loi = "LOI",
  agreement = "Agreement",
  invoice = "Invoice",
  lost = "Lost",
}

export enum EventStatuses {
  Active = "active",
  Completed = "completed",
  Cancelled = "cancelled",
  Rescheduled = "rescheduled",
}

export enum VisibilityLevel {
  OwnerOnly = "OwnerOnly",
  OwnersVisibilityGroup = "OwnersVisibilityGroup",
  OwnersVisibilityGroupAndSubGroup = "OwnersVisibilityGroupAndSubGroup",
  EntireCompany = "EntireCompany",
}

export enum VisibilityGroupOwnerType {
  CrmAgent = "CrmAgent",
  SalesPerson = "SalesPerson",
  Createdby = "Createdby",
  Cancelledby = "Cancelledby",
  ApprovedBy = "Approvedby",
  RejectedBy = "Rejectedby",
  EventAssignee = "EventAssignee",
  UnAssigned = "UnAssigned",
  OnlineLeads = "OnlineLeads",
  Showroom = "Showroom",
}
export enum TestDriveInititationStatuses {
  Inititated = "inititated",
  Started = "started",
  Stopped = "stopped",
  Completed = "completed",
  Cancelled = "cancelled",
}
export enum DashboardStages {
  Lead = "lead",
  Opportunity = "opportunity",
  Requirement = "requirement",
  Proposal = "proposal",
  SiteVisit = "site visit",
  Termsheet = "termsheet",
  Agreement = "agreement",
  Invoice = "invoice",
}
export interface StageTransition {
  stageId: string;
  name: string;
  code: string;
  startedOn?: Date;
  finishedOn?: Date;
  position: number;
  sla?: number;
  isCurrentStage?: boolean;
}

export interface LeadBuyingInfluence {
  buyingInfluenceId: string;
  _id?: string;
  userId: string;
  userName: string;
  avatar?: MediaFile;
  buyingInfluenceName: string;
  score: number;
}

export interface LeadDemographic {
  ageRange?: string;
  bloodGroup?: string;
  nationality?: string;
  isAlghanimEmployee?: boolean;
  profession?: string;
  sensitiveCustomer?: boolean;
  tags?: string[];
  maritalStatus?: string;
  numberOfChildren?: number;
  children?: LeadDemographicChildrens[];
  languagesSpeak?: string[];
  preferredLanguage?: string;
  gender?: string;
  dob?: string;
  pfNumber?: number;
  incomeRange?: string;
}

interface LeadDemographicChildrens {
  name: string;
  age: number;
  gender: string;
}

export interface LeadCustomerDetails {
  _id: string;
  prefix?: string;
  firstName: string;
  lastName?: string;
  middleName?: string;
  fullName?: string;
  phone?: string;
  email?: string;
  civilId?: string;
  magicNumber?: string;
  governorate?: string;
  district?: string;
  houseNumber?: string;
  houseName?: string;
  block?: string;
  street?: string;
  postalCode?: string;
  avatar?: MediaFile;
  photo?: MediaFile;
  address?: string;
  city?: string;
  area?: string;
  country?: string;
  isCompanyCustomer?: boolean;
}

export interface PartnerInfo {
  name: string;
  partnerRelation?: string;
  userId?: string;
  customerId?: string;
}

export interface VehicleUserDetails {
  name?: string;
  relationWithOwner?: string;
  vehicle: string;
  userId?: string;
  user?: Customer;
  userName?: string;
  avatar?: MediaFile;
  _id?: string;
  wavierForm?: MediaFile;
}

export interface CustomerAnswers {
  questionId: string;
  _id?: string;
  question: string;
  translations?: { question?: Translations };
  answer: any;
}

export interface ActionObject {
  title: string;
  dueDate: Date;
  actionId: string;
}

export interface Configuration {
  totalPrice: number;
  _id?: string;
  vehicle?: VehicleConfiguration;
  accessories?: Accessories[];
  insurance?: Insurance;
  tradeIns?: TradeIn[];
}

export interface Accessories {
  _id: string;
  productID: number;
  productCategoryName: string;
  productType: string;
  productTitle: string;
  productDescription: string;
  productImage: string;
  productPreviewImage: string;
  offerPrice: 0.9;
}

export interface Insurance {
  productID: number;
  productTitle: string;
  salesPrice: number;
  offerPrice: number;
  minimumPremium: number;
  planImage: string;
  planFile: string;
}

export interface TradeIn {
  _id: string;
  modelYear: number;
  brandName: string;
  modelCode: string;
  trimCode: string;
  mileage: number;
  specs: string;
  registrationNumber: number;
  ownership: string;
  hasHypothecation: boolean;
  expectedTradeInValue: number;
  hypothecationAmount: number;
}

export interface VehicleConfiguration {
  model: { name: string; _id: string; year: string };
  variant: { name: string; _id: string };
  color: string;
  isPrimary: true;
  basePrice: number;
  interior: { colorCode: string; colorDescription: string; image: string };
  exterior: { colorCode: string; colorDescription: string; image: string };
}

export interface ILeadActivity {
  _id: string;
  isCompleted: boolean;
  type: string;
  title: string;
  note: string;
  createdAt: Date;
  updatedAt: Date;
  event?: ILeadEvent;
  leadTitle?: string;
  file?: MediaFile;
  status?: string;
  isEditable?: boolean;
  createdBy: {
    name: string;
    _id: string;
  };
  triggeredBy?: string;
  leadId?: string;
  overnightTestdriveEnabled?: boolean;
  testDriveInitiationStatus?: TestDriveInititationStatuses;
  realTimeTestDriveEndTime?: Date;
  realTimeTestDriveStartTime?: Date;
  startDate?: Date;
  companyPeople?: any;
}

export interface ICalendarEventListItem {
  _id: string;
  isRescheduled: boolean;
  isNoshow: boolean;
  isCompleted: boolean;
  isCancelled: boolean;
  isDeleted: boolean;
  title: string;
  startDate: string;
  note: string;
  activityType: string;
  assignedPerson: AssignedPerson;
  showroom?: ILeadShowroom;
  createdAt: string;
  activity: string;
  endDate?: string;
  createdBy?: AssignedPerson;
  actionCode?: string;
  actionId?: string;
  customer?: IEventCustomer;
  leadTitle?: string;
  status?: string;
  vehicleModel?: VehicleModelMinimal;
  vehicleVariant?: VehicleVariantMinimal;
  leadId?: string;
  vehicle?: IEventVehicle;
  bookedBy?: IEventStaff;
  address?: any;
  noteType?: NoteTypes;
  completedOn?: string;
  cancelledOn?: string;
  overnightTestdriveEnabled?: boolean;
  mileageIn?: number;
  mileageOut?: number;
  cancellationReason?: string;
  cancellationNote?: string;
  ownersVisibilityGroups?: OwnerVisibilityGroups[];
  leadPrimaryVehicleModel?: {
    name?: string;
  };
  participants?: LeadCustomerDetails[]
}

export interface OwnerVisibilityGroups {
  visibilityGroupId?: string;
  visibilityGroupName?: string;
  visibilityLevel?: VisibilityLevel;
  userId?: string;
  ownerType?: VisibilityGroupOwnerType;
  meta?: VisibilityGroupMetaInfo;
}

export class VisibilityGroupMetaInfo {
  eventId?: string;
  unAssigneeType?: string;
}

export interface ICalendarEventResponse {
  count: number;
  appointments: Appointment[];
  assignees?: Assignee[];
  vehicles: IVehicleModel[];
  staffLeaves: IStaffLeave[];
  showroomTimings: ShowroomTiming[];
}
export interface ShowroomTiming {
  showroom: Showroom2;
}

interface Showroom2 {
  date: string;
  day: string;
  shifts: Shift[];
  _id: string;
  title: string;
}
export interface Shift {
  _id: string;
  start: string;
  end: string;
}

export interface IShowroomShift {
  _id: string;
  start: Date;
  end: Date;
}

export interface IStaffLeave {
  _id: string;
  isShowUp: boolean;
  status: string;
  busyEvent: boolean;
  isRescheduled: boolean;
  isNoshow: boolean;
  isCompleted: boolean;
  isCancelled: boolean;
  isDeleted: boolean;
  timeOffType: string;
  startDate: Date;
  endDate: Date;
  note: string;
  activityType: string;
  title: string;
  createdBy: {
    name: string;
    _id: string;
  };
  assignedPerson: AssignedPerson;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}
export interface IVehicleModel {
  name: string;
  _id: string;
  code: string;
  year: string;
}
export interface Assignee {
  _id: string;
  name: string;
  showroom: IShowrrom;
  showrooms: IShowrrom[];
  avatar?: MediaFile;
  knownAs?: string;
}
export interface Appointment {
  companyId?: string;
  leadDetails: any;
  companyName?: string;
  companyPeople?: any[];
  startDate: Date;
  endDate?: Date;
  _id: string;
  actionCode?: string;
  activityType: string;
  title: string;
  assignedPerson: AssignedPerson;
  note?: string;
  isCompleted?: boolean;
  vehicleModel?: IEventVehicleModel;
  customer?: IEventCustomer;
  vehicle?: IEventVehicle;
  bookedBy?: IEventStaff;
  status?: string;
  address?: any;
  leadId?: string;
}

export interface AssignedPerson {
  _id?: string;
  name?: string;
  showrooms?: IShowrrom[];
  showroom?: IShowrrom;
  avatar?: any;
  knownAs?: string;
}
interface IEventVehicle {
  name: string;
  displayName: string;
  _id: string;
  price: number;
  exterior: Exterior;
  interior: Exterior;
  sku: string;
}

export interface Exterior {
  colorCode: string;
  colorDescription: string;
  image?: string;
  isDefault?: boolean;
}

interface IEventCustomer {
  _id: string;
  fullName: string;
  email: string;
  phone: string;
  avatar?: MediaFile;
}

interface IEventStaff {
  _id: string;
  name: string;
  email: string;
  phone: string;
  avatar?: MediaFile;
}

interface IEventVehicleModel {
  _id: string;
  name: string;
  code?: string;
  modelCode?: string;
  year?: string;
}

export interface IAddLeadActivityModel {
  type: string;
  title?: string;
  startDate?: Date;
  endDate?: Date;
  salesPerson?: any;
  companyPeople?: any;
  leadId?: string;
  documentId?: string;
  note?: string;
  file?: MediaFile;
  busyEvent?: boolean;
  noteType?: NoteTypes;
  companyId?: string;
  activityCategory?: string;
}

export interface IUpdateEventModel {
  activityType?: string;
  type?: string;
  title?: string;
  startDate: Date;
  endDate: Date;
  assignedPersonId?: string;
  leadId?: string;
  note?: string;
  showroom?: string;
  vehicleModelId?: string;
  vehicleId?: string;
  busyEvent?: boolean;
  testDriveLocation?: string;
  modelCode?: string;
  variantCode?: string;
  year?: string;
  vehicle?: string;
  overnightTestdriveEnabled?: boolean;
  users?: string[];
  companyPeople?: any[];
  companyId?: string;
}

export interface IEmail {
  email: string;
  emailType: string;
  isPrimary: boolean;
}
export interface IAssignedPerson {
  _id: string;
  languages: any[];
  accountType: string;
  isActive: boolean;
  email: string;
  name: string;
  franchise: string;
  emails: IEmail[];
  username: string;
  drivingLicenses: any[];
  phones: any[];
  createdAt: Date;
  updatedAt: Date;
  __v: number;
  knownAs: string;
}
export interface ILeadEvent {
  projectId?: string;
  propertyId?: string;
  activityCategory: string | undefined;
  _id: string;
  startDate: Date;
  busyEvent?: boolean;
  endDate: Date;
  isCompleted: boolean;
  assignedPerson: IAssignedPerson;
  leadId: string;
  title: string;
  activityType: string;
  actionId: string;
  vehicleModel?: VehicleModelMinimal;
  vehicleVariant?: VehicleVariantMinimal;
  year?: string;
  vehicle?: { _id: string; displayName: string };
  showroom: ILeadShowroom;
  note: string;
  createdBy: ILeadShowroom;
  createdAt: string;
  updatedAt: string;
  __v: number;
  activity: string;
  testDriveLocation?: string;
  address?: any;
  customer?: Customer;
  status?: string;
  overnightTestdriveEnabled?: boolean;
  mileageIn?: string;
  mileageOut?: string;
  users?: Customer[];
  companyPeople?: Customer[];
  companyId: string;
}
interface ILeadShowroom {
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  title: string;
  address: any;
  location: Location;
  locationCode: string;
  name?: string
}

interface IDropdownModel {
  name: string;
  _id: string;
}

export interface LeadMinimal {
  _id?: string;
  title?: string;
  isDeal?: boolean;
  currentStatus?: LeadStatuses;
  isActive?: boolean;
  isDeleted?: boolean;
  enquiryNumber?: string;
}

export interface Lead extends LeadMinimal {
  isArchived?: boolean;
  utm_medium?: string;
  campaignid?: string;
  quality?: LeadQuality;
  stagesTransitions?: StageTransition[];
  currentStageCode?: string;
  pipelineId?: string;
  newness?: LeadNewnesses;
  initialTouchPoint?: {
    name: string;
    _id: string;
  };
  businessSource?: {
    _id: string;
    name: string;
    autoLineId?: string;
    code?: string;
    parentId?: string;
  };
  leadSource?: {
    _id: string;
    name: string;
    code?: string;
  };
  buyingInfluences?: LeadBuyingInfluence[];
  franchise?: string;
  previousSalesPerson?: OwnerUser;
  salesUpdatedAt?: Date;
  crmUpdatedAt?: Date;
  currentSalesPerson?: OwnerUser;
  previousCRMAgent?: OwnerUser;
  leadAssigneeHead?: OwnerUser;
  currentCRMAgent?: OwnerUser;
  leadManager?: OwnerUser;
  groupManager?: OwnerUser
  telecaller?: OwnerUser
  intercityUser?: OwnerUser
  leadIntent?: {
    name: string;
    _id: string;
  };
  customer?: Customer;
  note?: string;
  activities?: string[];
  leadType?: {
    name: string;
    _id: string;
  };
  productTypeInterested?: {
    name: string;
    _id: string;
  };
  decisionTimeFrame?: {
    name: string;
    _id: string;
  };
  expectedClosingDate?: Date;
  priority?: Priorities;
  tags?: string[];
  primaryVehicleModel?: VehicleModelMinimal;
  primaryVehicleVariant?: VehicleVariantMinimal;
  parentLeadId?: string;
  actions?: ActionObject[];
  customerAnswers?: CustomerAnswers[];
  partnerInfo?: PartnerInfo;
  vehicleDetails?: VehicleUserDetails;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  vehicles?: LeadVehicle[];
  interestedProject?: LeadInterestedProject[];
  sourceInputData?: any;
  leadChannel?: string;
  showroomId?: string;
  qualityInfo?: {
    reason?: string;
    _id?: string;
    nextContactDate?: Date;
    code?: string;
    comment?: string;
    contactAfter?: string;
  };
  showroom?: Showroom;
  nextActivityDate?: string | Date;
  lastActivityDueOn?: string | Date;
  lostRequestDetails?: {
    approvalStatus: GeneralApprovalStatus;
    initiatedBy: OwnerUser;
    requestedAt: Date;
    validatedBy: OwnerUser;
    validatedAt: Date;
  };
  crmChangeReason?: LeadAssigneeChangeReason;
  salesChangeReason?: LeadAssigneeChangeReason;
  customerReqSalesPerson?: boolean;
  createdBy?: OwnerUser;
  isEditable?: boolean;
  lastNote?: {
    note: string;
  };
  haveShowroomVisit?: boolean;
  haveTestDrive?: boolean;
  dummyVehicles?: LeadVehicle[];
  comments?: string[];
  lastLeadActivity?: {
    activityType: string;
    _id?: string;
    date: Date;
    createdDate?: Date;
    completed?: boolean;
  };
  firstFollowUpDate?: Date;
  latestFollowUpDate?: Date;
  enquiryNumber?: string;
  serviceAdvisorLead?: boolean;
  bodyShopLead?: boolean;
  corporateUsers?: Customer[];
  company?: Company;
  requirements?: LeadRequirement[];
  cities?: string;
  microMarkets?: string[];
  preferredLocations?: string[];
  projectType?: ObjectType;
  propertyType?: ObjectType;
  minPrice?: string | number;
  maxPrice?: string | number;
  minArea?: string | number;
  maxArea?: string | number;
  weightage?: string | number;
  floorPreferences?: string[];
  preferedProjects?: string[];
  preferredDevelopers?: string[];
  cityDetails?: {
    _id: string;
    cityName: string;
  };
  microMarketDetails?: string[];
  preferredLocationDetails?: string[];
  floorPreferenceDetails?: string[];
  preferedDeveloperDetails?: string[];
  preferedProjectDetails?: string[];
  propertyTypeDetails?: {
    _id: string;
    propertyTypeName: string;
  };
  projectTypeDetails?: {
    _id: string;
    // projectTypeName: string;
    propertyTypeName: string;
  }[];
}

export interface LeadDetails extends Lead {
  configurations?: LeadConfiguration[];
}
export interface LeadInterestedProject {
  _id?: string;
  project?: {
    _id: string;
    projectName: string;
  };
  property?: {
    _id: string;
    propertyName: string;
  };
  createdBy?: OwnerUser;
}
export interface LeadVehicle {
  _id?: string;
  color: string;
  trim: string;
  model: VehicleModelMinimal;
  year: string;
  combination?: {
    _id: string;
    ecomId: string;
    ecomHash: string;
    ecomSKU: string;
    price: number;
    interior: {
      colorCode: string;
      colorDescription: string;
      image?: string;
      ecomId: string;
    };
    exterior: {
      colorCode: string;
      colorDescription: string;
      image?: string;
      ecomId: string;
    };
  };
  variant: VehicleVariantMinimal;
  ecomId?: string;
  basePrice?: number;
  isPrimary?: boolean;
  createdBy?: OwnerUser;
}

interface ObjectType {
  name?: string;
  value?: string;
}

export interface CreateLead {
  _id?: string;
  leadType?: string;
  leadIntent?: string;
  customerId?: string;
  companyId?: string;
  initialTouchPoint?: string;
  leadSource?: string;
  contactIds?: string[];
  propertyType?: string;
  decisionTimeframe?: string;
  title?: string;
  cities?: ObjectType;
  microMarkets?: string[];
  preferredLocations?: string[];
  projectType?: ObjectType;
  minPrice?: string | number;
  maxPrice?: string | number;
  minArea?: string | number;
  maxArea?: string | number;
  weightage?: string | number;
  floorPreferences?: string[];
  preferedProjects?: string[];
  preferredDevelopers?: string[];
  note?: string;
}

export interface CreateVehicle {
  actionId?: string;
  modelCode?: string;
  variantCode?: string;
  year?: string;
  color?: string;
  trim?: string;
  isPrimary?: boolean;
  _id?: string;
}

export interface CreateInterestedProject {
  projectId?: string[];
  propertyId?: string[];
  leadId?: string;
  _id?: string;
}

export interface AssignCompanyLead {
  company: Company;
  people: Customer[]
}

export interface CreateScheduleATestDrive {
  actionId: string;
  showroom?: string;
  modelCode: string;
  variantCode: string;
  year: string;
  vehicle?: string;
  salesPerson?: string;
  startDate?: Date;
  endDate?: Date;
  note?: string;
  startTime?: string;
  endTime?: string;
  busyEvent?: boolean;
  timePeriod?: ITimePeriodData;
  location?: string;
  testDriveLocation?: string;
  address?: any;
  startTimePeriod?: ITimeData;
  endTimePeriod?: ITimeData;
  licenseFront?: any;
  licenseBack?: any;
  overnightTestdriveEnabled?: boolean;
  users?: string[];
}

export interface CreateShowroomVisit {
  actionId: string;
  showroom?: string;
  salesPerson?: string;
  scheduleStartDate?: Date;
  scheduleEndDate?: Date;
  note?: string;
  startTime?: string;
  endTime?: string;
  busyEvent?: boolean;
  timePeriod?: ITimePeriodData;
  users?: string[];
}

export interface CreateRequestACallbackt {
  actionId: string;
  showroom?: string;
  salesPerson?: string;
  scheduleStartDate?: Date;
  scheduleEndDate?: Date;
  note?: string;
  startTime?: string;
  endTime?: string;
  busyEvent?: boolean;
  timePeriod?: ITimePeriodData;
  users?: string[];
}

export interface LeadQualityChange {
  quality?: string;
  reason?: string;
  nextContactDate?: Date;
  comment?: string;
  contactAfter?: string;
  actionId?: string;
  showroom?: string;
  salesPersonId?: string;
  startDate?: Date;
  endDate?: Date;
  note?: string;
  startTime?: string;
  endTime?: string;
  busyEvent?: boolean;
  timePeriod?: ITimePeriodData;
  otherReason?: string;
}

export interface IMarkAsLost {
  reason?: string;
  otherReason?: string;
  nextContactDate?: Date;
  comment?: string;
  contactAfter?: string;

  actionId?: string;
  showroom?: string;
  salesPerson?: string;
  scheduleStartDate?: Date;
  scheduleEndDate?: Date;
  note?: string;
  startTime?: string;
  endTime?: string;
  busyEvent?: boolean;
  timePeriod?: ITimePeriodData;
}

export interface ILeadBulkAssign {
  leadIds: string[];
  showroomId?: string;
  cityId?: string;
  crmAgentId?: string;
  salesPersonId?: string;
  reason?: string;
}

export interface ILeadAction {
  _id: string;
  name: string;
  code: string;
}

export interface Lead360Data {
  customer: Customer;
  leads: Lead[];
  leadActions: { leadId: string; actions: ILeadAction[] }[];
  configurations?: LeadConfiguration[];
  users?: Customer[];
  company?: Company;
  requirements?: LeadRequirement[];
  proposals?: Proposal[];
  agreements?: GenericDocuments[];
  invoices?: GenericDocuments[];
}

export interface Tag {
  tags?: string[];
}

export interface ICancelReason {
  reason: string;
}

export interface ChangeLeadAssigneeReason {
  _id?: string;
  code: string;
  reason: string;
  visibility?: boolean;
  entityType: string;
}

export interface ILeadQuality {
  _id?: string;
  code: string;
  name: string;
  isLostQuality?: boolean;
  isContactAfterRequired?: boolean;
}

export interface ILeadQualityReason {
  _id?: string;
  code: string;
  reason: string;
  isSelectableForEnquiry?: boolean;
  isSelectableForLead?: boolean;
  translations?: { reason?: Translations };
  quality: string[];
}

export interface IBank {
  name: string;
  bankID: string;
  _id: string;
}

export interface IExteriorColor {
  _id: string;
  colorCode: string;
  colorDescription: string;
  colorHex?: string;
}

export interface IPhysicalLocation {
  _id: string;
  name: string;
  locationCode: string;
  accountNumber?: number;
  address?: string;
  latitude?: number;
  longitude?: number;
}

export interface IInteriorColor {
  _id: string;
  colorCode: string;
  colorDescription: string;
  colorHex?: string;
}

export interface IFinanceOwingBank {
  name: string;
  shortName: string;
  accountNumber: string;
  translations?: { name?: Translations };
  _id: string;
}

export interface IExcessAmountAdjustmentType {
  _id: string;
  name: string;
  autolineCode: string;
  accountNumber?: string;
  isSupplementary?: boolean;
}

export interface IInvoiceCancellationReason {
  reason: string;
  _id: string;
}
export interface ILeadGridView {
  leads: Lead[];
  count: number;
  stage: string;
  count_no: number;
  count_today: number;
  count_overdue: number;
  count_future: number;
}

export interface CancellationReason {
  _id?: string;
  code?: string;
  reason: string;
  translations?: { reason?: Translations };
}

export interface SatisfactionReason {
  _id?: string;
  code?: string;
  reason: string;
  translations?: { reason?: Translations };
}

export interface SatisfactionLevel {
  _id?: string;
  code?: string;
  reason: string;
  translations?: { reason?: Translations };
  isSendToShowroomManager?: boolean;
}

export interface BlockingReason {
  _id?: string;
  code?: string;
  reason: string;
  translations?: { reason?: Translations };
}

export interface LeadAssigneeChangeReason {
  _id?: string;
  code?: string;
  reason: string;
  translations?: { reason?: Translations };
}

export interface LeadLostRequest {
  _id: string;
  isActive: boolean;
  currentStatus: string;
  isDeal: boolean;
  approvalStatus: string;
  reason: string;
  reasonId: string;
  reasonCode: string;
  leadId: string;
  comments: string;
  customer?: Customer;
  title: string;
  stageCode: string;
  createdBy: OwnerUser;
  createdAt: Date;
  updatedAt: Date;
}
export enum GeneralApprovalStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
}

export interface PreBookingAvailabilityRejectReason {
  _id?: string;
  reason: string;
}
export interface UpdateLeadDetails {
  _id?: string;
  leadType?: string;
  businessSource?: string;
  initialTouchPoint?: string;
  showroomId?: string;
  // previousSalesPerson?: string;
  // currentSalesPerson?: string;
}

export interface ITimeData {
  startDate?: Date;
  startTime?: string;
  endDate?: Date;
  endTime?: string;
}

export interface Industry {
  _id?: string;
  name: string;
  translations?: { name?: Translations };
}
export interface Sector {
  _id?: string;
  name: string;
  translations?: { name?: Translations };
}
export interface CompanySegment {
  _id?: string;
  name: string;
  translations?: { name?: Translations };
}

export interface AssigneePerson {
 leadManagerId?: string;
 groupManagerId?:string;
 telecallerId?: string;
 intercityUserId?: string;
 type?: string
}
